<div class="coming-soon-modal" *ngIf="!this.data.sameCoursePresent">
    <div class="text-center">
        <img *ngIf="!data?.purchaseAgain" class="img" src="assets/img/coming-soon-icon.svg" alt="">
        <h3 [ngClass]="{'purchaseAgain-title': data?.purchaseAgain}">{{data.message1?data.message1:'Great!'}}!</h3>
        <span *ngIf="!data?.purchaseAgain"><p [innerHTML]="data.message2?data.message2:'Great you have been registered successfully'"></p></span>
        <button *ngIf="showCloseBtn" class="btn-link" type="button" (click)="onClose()">CLOSE</button>
        
        <div *ngIf="data?.purchaseAgain">
            <button [ngClass]="{'purchaseAgain-btn': data?.purchaseAgain}" class="btn-link" type="button" (click)="purchaseAgain()">Purchase again</button>
        </div>
        <div class="btn-area" *ngIf="data?.purchaseAgain">
            <button class="explore" type="button" (click)="explorePackages()">Explore other packages</button>
        </div>
    </div>
</div>

<div class="coming-soon-modal" *ngIf="this.data.sameCoursePresent">
    <div class="text-center">
        <span *ngIf="!data?.purchaseAgain"><p>Multiple packages in cart have the same 
            course. Please add only one package 
            per course to continue.</p></span>
        <button *ngIf="showCloseBtn" class="btn-link" type="button" (click)="onClose()">CLOSE</button>
    </div>
</div>